const translate = {
    rating_button_text: 'Oceń telefon'
};

export default translate;
